/* eslint-disable */
import { Module, MutationTree, GetterTree } from "vuex";
import { ActionTree } from "vuex";
import { NotificationsGroupsState } from "../types/NotificationsGroupsState";
import { NotificationBadgeGroups } from "@/components/Agents/NotificationBadge.vue";

export const state: NotificationsGroupsState = {
  company: 0,
  products: 0,
  multipleProducts: 0,
  matchProblems: 0,
  companyAssociationDuplicates: 0,
  reload: {
    [NotificationBadgeGroups.Company]: false,
    [NotificationBadgeGroups.Products]: false,
    [NotificationBadgeGroups.MultipleProducts]: false,
    [NotificationBadgeGroups.MatchProblem]: false,
    [NotificationBadgeGroups.CompanyAssociationDuplicates]: false,
  },
};

export const getters: GetterTree<NotificationsGroupsState, unknown> = {
  company(state): number {
    return state.company;
  },

  products(state): number {
    return state.products;
  },

  multipleProducts(state): number {
    return state.multipleProducts;
  },

  matchProblems(state): number {
    return state.matchProblems;
  },

  companyAssociationDuplicates(state): number {
    return state.companyAssociationDuplicates;
  },

  reload(state): Record<NotificationBadgeGroups, boolean> {
    return state.reload;
  },
};

export const mutations: MutationTree<NotificationsGroupsState> = {
  setCompany(state, total: number) {
    state.company = total;
  },

  setProducts(state, total: number) {
    state.products = total;
  },

  setMultipleProducts(state, total: number) {
    state.multipleProducts = total;
  },

  setMatchProblems(state, total: number) {
    state.matchProblems = total;
  },

  setCompanyAssociationDuplicates(state, total: number) {
    state.companyAssociationDuplicates = total;
  },

  setReloadGroupOn(state, groupname: NotificationBadgeGroups) {
    state.reload[groupname] = true;
  },

  setReloadGroupOff(state, groupname: NotificationBadgeGroups) {
    state.reload[groupname] = false;
  },
};

export const actions: ActionTree<NotificationsGroupsState, unknown> = {
  valorizeCompany({ commit }, total: number) {
    commit("setCompany", total);
  },

  valorizeProducts({ commit }, total: number) {
    commit("setProducts", total);
  },

  valorizeMultipleProducts({ commit }, total: number) {
    commit("setMultipleProducts", total);
  },

  valorizeMatchProblems({ commit }, total: number) {
    commit("setMatchProblems", total);
  },

  valorizeCompanyAssociationDuplicates({ commit }, total: number) {
    commit("setCompanyAssociationDuplicates", total);
  },

  reload({ commit }, groupname: NotificationBadgeGroups) {
    commit("setReloadGroupOn", groupname);
  },

  stopReload({ commit }, groupname: NotificationBadgeGroups) {
    commit("setReloadGroupOff", groupname);
  },
};

export const notificationsGroups: Module<NotificationsGroupsState, unknown> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
